/* /src/components/auth/callback.jsx */
import React from "react";
import { AuthConsumer } from '../../contexts/authProvider';
import LoadingIndicator from '../wrapper/LoadingIndicator/LoadingIndicator';

export const Callback = () => (
    <AuthConsumer>
        {({ signinRedirectCallback }) => {
            signinRedirectCallback();
            return <LoadingIndicator active={true} />;
        }}
    </AuthConsumer>
);